import React, { useState } from "react";
import InputBox from "../../../components/InputBox";
import { Button } from "src/business-types/grocery/components/Button";
import { postCategory } from "../../../../../shared/services/services";
import { closeLoading, notifyLoading, notifySuccess } from "../../../../../assets/toastService";
import PopupModules from "src/features/auth/components/PopupModules";
import { errorHandling } from "src/shared/services/errorHandling";

type Props = {
  close: (data: any) => void;
  loading: (data: boolean) => void;
  addProduct: boolean;
};

function AddCategory({ close, loading, addProduct }: Props) {
  const [categoryName, setCategoryName] = useState<string>("");
  const [categorySecondName, setCategorySecondName] = useState<string>("");
  const [multibles, setMultibles] = useState<boolean>(false);

  const confirm = () => {
    if (categoryName) {
      const update = { CategoryName: categoryName, categorySecondName: categorySecondName };
      notifyLoading("Adding category...");
      postCategory(update)
        .then((res) => {
          closeLoading();
          notifySuccess("Category added successfully");
          loading(false);
          setCategoryName("");
          setCategorySecondName("");
          if (!multibles) {
            close(res);
          }
        })
        .catch((error) => {
          closeLoading();
          errorHandling(error);
        });
    }
  };
  return (
    <PopupModules isOpen={addProduct} onClose={() => close("")} title='Add New Categories'>
      <div className='py-2'>
        <div className='flex flex-col gap-2 m-2'>
          <p className='px-1'>Category Name</p>
          <InputBox maxLength={40} onChange={(e) => setCategoryName(e.target.value)} value={categoryName} />
        </div>
        <div className='flex flex-col gap-2 m-2'>
          <p className='px-1'>Second Name</p>
          <InputBox maxLength={40} onChange={(e) => setCategorySecondName(e.target.value)} value={categorySecondName} />
        </div>
        <div className='w-full flex gap-2 h-fit items-center m-2'>
          <input type='checkbox' className='w-5 h-5' defaultChecked={multibles} onChange={() => setMultibles(!multibles)} />{" "}
          <p>Add Multible Category</p>
        </div>
        <div className='w-full flex justify-center gap-2 mt-2'>
          <Button label='Cancel' variant='ThemeCancel' onClick={() => close("")} className='border' />
          <Button label='Confirm' variant='ThemeBase' onClick={confirm} disabled={!categoryName} />
        </div>
      </div>
    </PopupModules>
  );
}

export default AddCategory;
